// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ew3_","colBig":"styles_colBig__5-Wyg","colSmall":"styles_colSmall__2tQhA","shopifyNameWrapper":"styles_shopifyNameWrapper__2dv0U"};